<template>
  <div v-if="ticketDetail.isLast & ticketDetail.createUser.id == currentUserInfo.id & !(ticketDetail.isReferral)"
    class="modal fade" id="chatDelete" tabindex="-1" aria-labelledby="chatDelete" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-gradient-danger" id="warningModalHeader">
          <h5 class="modal-title" id="warningModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <h4>آیا از حذف این پیام اطمینان دارید؟!</h4>
          <p>تمام تغییرات مرتبط با این پیام بازگردانی می‌شوند.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gradient-success" data-bs-dismiss="modal">خیر</button>
          <button type="button" class="btn bg-gradient-danger" data-bs-dismiss="modal"
            @click="deleteDetail()">حذف</button>
        </div>
      </div>
    </div>
  </div>
  <div :id="dynamicId" class="d-flex">
    <div class="d-flex flex-column flex-fill"
      :class="ticketDetail?.selected ? 'inner-chat-selected' : ''">
      <div class="d-flex"
        :class="ticketDetail?.isReferral
          ? 'flex-row-reverse justify-content-center align-self-center'
          : (currentUserInfo?.customerId == ticketDetail?.createUser?.customerId ? 'align-self-start' : 'flex-row-reverse align-self-end')">
        <div class="chat row  m-1"
          :class="ticketDetail?.isReferral
          ? 'bg-chat-3 mw-75'
          : (currentUserInfo?.customerId == ticketDetail?.createUser?.customerId ? 'bg-chat-2' : 'bg-chat-1')">
          <chat-header :user="ticketDetail.createUser" />
          <div v-if="ticketDetail.repliedTicketDetail" class="d-flex">
            <div class="flex-fill border-end border-3 border-secondary replied-chat pe-1">
              <replied-chat-display :chat="ticketDetail.repliedTicketDetail" @click="$emit('repliedChatSelected', ticketDetail.repliedTicketDetail)" />
            </div>
          </div>
          <div v-if="ticketDetail?.isReferral" class="text-center m-1 pe-0">
            {{
              '(ارجاع به '
              +
              (
                ticketDetail.companyReferralBaseId
                ? ''
                :
                (
                  (
                    ticketDetail.receiverRoleTitle
                    ? ('نقش ' + ticketDetail.receiverRoleTitle)
                    : (ticketDetail.receiverUser.firstName + ' ' + ticketDetail.receiverUser.lastName + ' - ' + ticketDetail.receiverUser.postTitle)
                  )
                  +
                  ((ticketDetail.receiverRoleTitle || ticketDetail.receiverUser?.firstName) && ticketDetail.receiverSectionTitle ? ' -- ' : '')
                )
              )
              +
              (ticketDetail.receiverSectionTitle ? ('بخش ' + ticketDetail.receiverSectionTitle) : '')
              +
              ')'
            }}
          </div>
          <div v-if="ticketDetail?.message" class="m-1 pe-0 fs-5-6 pre-line">
            {{ ticketDetail?.message }}
          </div>
          <div
            v-if="currentUserInfo.customerId == null &
              ((ticketDetail.createUser.id == currentUserInfo.id & !(ticketDetail.isReferral)) | ticketDetail.timeSpent?.length > 0)">
            <div
              v-if="((ticketDetail.createUser.id == currentUserInfo.id & !(ticketDetail.isReferral)) | ticketDetail.timeSpent?.length > 0) & !editTime"
              class="d-flex flex-wrap justify-content-center align-items-center m-0 p-0">
              <div class="ps-1 m-1">مدت انجام: </div>
              <div class="d-flex align-middle time-info ms-1 ps-2 pe-2 lh-sm"
                :class="ticketDetail.createUser.id == currentUserInfo.id & !ticketIsClosed ? 'pointer' : ''" @click="toggleEditTime">
                {{ ticketDetail.timeSpent?.slice(0, 5) ?? '00:00' }}
              </div>
            </div>
            <div v-if="editTime" class="d-flex justify-content-center align-items-center m-0 p-0">
              <div class="d-flex">
                <button class="btn btn-sm btn-success p-2 mb-0 ms-1" @click="updateTimeSpent">ثبت</button>
                <button class="btn btn-sm btn-secondary p-2 mb-0" @click="toggleEditTime">انصراف</button>
              </div>
              <div class="d-flex">
                <date-picker class=" me-2 ms-2" clearable editable format="HH:mm:ss" displayFormat="HH:mm"
                  v-model="newTimeSpent" type="time" :jump-minute="5" :jumpSecond="60" :round-minute="true"
                  initial-value="00:00" />
              </div>
            </div>
          </div>
          <div v-if="ticketDetail?.files?.length > 0" class="row m-1 pe-0 ps-3">
            <chat-attachment v-for="f in ticketDetail.files" :file="f" />
          </div>
          <div v-if="ticketDetail?.ticketStatusHistory?.ticketStatus?.ticketStatusEnum > -1"
            class="d-flex flex-wrap justify-content-center fs-7 align-items-center m-0 p-0">
            <div class="ps-1">تغییر وضعیت تیکت به</div>
            <div class="d-flex">
              <div class="status ms-1 ps-2 pe-2"
                :class="ticketDetail.ticketStatusHistory?.ticketStatus.ticketStatusEnum == 0 ? 'status-danger' :
                  ticketDetail.ticketStatusHistory?.ticketStatus.ticketStatusEnum == 1 ? 'status-warning' :
                  ticketDetail.ticketStatusHistory?.ticketStatus.ticketStatusEnum == 2 ? 'status-primary' :
                  ticketDetail.ticketStatusHistory?.ticketStatus.ticketStatusEnum == 3 ? 'status-success' :
                  ticketDetail.ticketStatusHistory?.ticketStatus.ticketStatusEnum == 7 ? 'status-warning' : 'status-secondary'">
                {{ ticketDetail.ticketStatusHistory ? ticketDetail.ticketStatusHistory.ticketStatus?.title : "" }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between m-1 pe-0">
            <div></div>
            <div>
              {{ $filters.toTimeString(ticketDetail.createTime) }} - {{ $filters.toDateString(ticketDetail.createDate) }}
            </div>
          </div>
        </div>
        <div v-if="!ticketIsClosed" class="d-flex flex-column justify-content-end">
          <div v-if="ticketDetail.isLast & !ticketDetail.isFirst & ticketDetail.createUser.id == currentUserInfo.id & !ticketDetail.isReferral"
            class="text-danger pointer" data-bs-toggle="modal" data-bs-target="#chatDelete" title="حذف">
            <fa-icon icon="far fa-trash-can" />
          </div>
          <div v-if="!ticketDetail.isReferral" class="text-secondary pointer" @click="$emit('setToBeReplied', ticketDetail)" title="پاسخ">
            <fa-icon icon="fas fa-reply" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketService from '../../../services/Ticket/Ticket-service';
import ChatHeader from './ChatHeader.vue';
import ChatAttachment from './ChatAttachment.vue';
import RepliedChatDisplay from './RepliedChatDisplay.vue';

export default {
  components: { ChatHeader, ChatAttachment, RepliedChatDisplay },
  props: ['dynamicId', 'ticketDetail', 'ticketId', 'ticketIsClosed'],
  emits: ['submited', 'setToBeReplied', 'repliedChatSelected'],
  data() {
    return {
      currentUserInfo: {},
      editTime: false,
      newTimeSpent: null,
    };
  },
  methods: {
    toggleEditTime() {
      if (this.ticketDetail.createUser.id == this.currentUserInfo.id & !this.ticketIsClosed)
        this.editTime = !(this.editTime);

      if (this.editTime)
        this.newTimeSpent = this.ticketDetail.timeSpent;
    },
    updateTimeSpent() {
      if (this.ticketDetail.timeSpent != this.newTimeSpent) {
        let vm = {
          Id: this.ticketDetail.id,
          Message: this.ticketDetail.message,
          TicketId: this.ticketId,
          TimeSpent: this.newTimeSpent > "00:00:59" ? this.newTimeSpent.slice(0, 6) + "00" : null,
        }

        TicketService.modifyTicketDetailByCreator(vm).then(response => {
          let result = response.data;

          if (result.success) {
            this.ticketDetail.timeSpent = this.newTimeSpent > "00:00:59" ? this.newTimeSpent : null;

            this.toggleEditTime();
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        this.toggleEditTime();
      }
    },
    deleteDetail() {
      let vm = {
        ticketId: this.ticketId,
        ticketDetailId: this.ticketDetail.id
      };
      
      TicketService.deleteTicketDetailByCreator(vm).then(response => {
        let result = response.data;

        if (result.success) {
          this.$emit('submited');
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
  },
  created() {
    this.currentUserInfo = this.$store.state.currentUserInfo;
  }
}
</script>